import { formatPrice } from '@aboutyou/legacy-shared/src/utils/currency'
import { useCurrency } from 'store/features/locale/useCurrency'

export const usePriceFormatter = (options?: { withoutDecimal: boolean }) => {
  const currency = useCurrency()

  return (price: number, currencyCode: string) =>
    formatPrice(price, currencyCode, currency, {
      ...options,
    })
}
